import { FieldProps, useFormikContext } from 'formik';
import { useCallback } from 'react';
import UDFormFieldWrapper from 'ud-form/wrapper';
import UDColorInput, { UDColorInputProps } from './component';
import { UDFormComponentProps } from '../types';

export type UDFormColorInputProps = UDFormComponentProps & Omit<UDColorInputProps, 'value' | 'onBlur' | 'hasError'>;

/**
 * Formik-поле выбора цвета: свотч плюс hex-строка в общей обёртке `ud-form`
 * (лейбл, ошибка, `containerProps`) — как `UDFormSelect` и `UDFormInput`.
 */
const UDFormColorInput = (props: UDFormColorInputProps) => {
  const { name, containerProps, label, labelProps, required, errorVisible, tooltip, tooltipProps, onChange, ...otherProps } = props;

  const { setFieldValue, setFieldTouched } = useFormikContext();

  const handleChange = useCallback(
    (value: string) => {
      setFieldValue(name, value);
      onChange?.(value);
    },
    [name, onChange, setFieldValue],
  );

  const handleBlur = useCallback(() => {
    setFieldTouched(name, true);
  }, [name, setFieldTouched]);

  return (
    <UDFormFieldWrapper
      name={name}
      containerProps={containerProps}
      label={label}
      labelProps={labelProps}
      required={required}
      errorVisible={errorVisible}
      tooltip={tooltip}
      tooltipProps={tooltipProps}
    >
      {({ field, meta }: FieldProps<any>) => (
        <UDColorInput
          {...otherProps}
          value={field.value}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={Boolean(meta.error) && (meta.touched || Boolean(meta.value))}
        />
      )}
    </UDFormFieldWrapper>
  );
};

export default UDFormColorInput;
